import { render, staticRenderFns } from "./QuestionMarkSettingsForm.vue?vue&type=template&id=fcd697f4&scoped=true"
import script from "./QuestionMarkSettingsForm.vue?vue&type=script&lang=js"
export * from "./QuestionMarkSettingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd697f4",
  null
  
)

export default component.exports